import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';
import { SequenceGraph } from '../outreach/SequenceGraph';

type AutomationPayload = {
  name: string;
  steps?: unknown[];
  [key: string]: unknown;
};

type SequenceGraphPayload = {
  automation: AutomationPayload;
  enrolled: Array<{ state: string; [key: string]: unknown }>;
};

export function SequenceGraphWidget(props: WidgetProps) {
  const data = decodeWidgetData(props.payload) as Partial<SequenceGraphPayload>;
  const automation = data.automation;

  if (!automation?.name) {
    return <p className="text-sm text-foreground-mute">No sequence data.</p>;
  }

  // SequenceGraph renders the step timeline; it takes { steps: Step[] }.
  // automation.steps may be undefined for empty automations — default to [].
  const steps = (automation.steps ?? []) as Parameters<typeof SequenceGraph>[0]['steps'];
  const enrolled = data.enrolled ?? [];
  const activeCount = enrolled.filter((e) => e.state === 'active').length;
  const exitedCount = enrolled.filter((e) => e.state === 'exited').length;

  return (
    <div className="space-y-4">
      <div className="flex items-baseline gap-3">
        <h3 className="text-foreground font-semibold">{automation.name}</h3>
        <span className="text-foreground-mute text-xs">
          {activeCount} active · {exitedCount} exited
        </span>
      </div>
      {steps.length === 0 ? (
        <p className="text-foreground-mute text-sm">No steps defined.</p>
      ) : (
        <SequenceGraph steps={steps} />
      )}
      {enrolled.length > 0 && (
        <div>
          <p className="text-foreground-mute text-xs font-medium mb-1">Enrolled</p>
          <ul className="space-y-1">
            {enrolled.map((e, i) => {
              const pid = (e as { prospectId?: string }).prospectId ?? `prospect-${i}`;
              return (
                <li key={pid} className="text-xs text-foreground-mute">
                  <span className="text-foreground">{pid}</span>
                  {' '}— {e.state}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
